import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  BankChargeDto,
  BankChargeListDto,
  BankChargeFilterDto,
  CreateBankChargeRequest,
  UpdateBankChargeRequest,
} from '@/types/bankCharge.types';

export const bankChargeApi = {
  /** GET /api/v1/bank-charges — paginated list */
  getList: (filter?: BankChargeFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<BankChargeListDto>>>('/bank-charges', { params: filter }),

  /** GET /api/v1/bank-charges/{id} — full bank charge detail */
  getById: (id: string) =>
    apiClient.get<ApiResponse<BankChargeDto>>(`/bank-charges/${id}`),

  /** POST /api/v1/bank-charges — create new bank charge (Draft) */
  create: (data: CreateBankChargeRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/bank-charges', data),

  /** PUT /api/v1/bank-charges/{id} — update draft bank charge */
  update: (id: string, data: UpdateBankChargeRequest) =>
    apiClient.put<ApiResponse<object>>(`/bank-charges/${id}`, data),

  /** POST /api/v1/bank-charges/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-charges/${id}/submit`),

  /** POST /api/v1/bank-charges/{id}/approve — approve the bank charge */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-charges/${id}/approve`, { remarks }),

  /** POST /api/v1/bank-charges/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-charges/${id}/reject`, { reason }),

  /** POST /api/v1/bank-charges/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-charges/${id}/post`),

  /** POST /api/v1/bank-charges/{id}/reverse — create reversal bank charge */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/bank-charges/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/bank-charges/{id}/cancel — cancel the bank charge */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/bank-charges/${id}/cancel`, { reason }),

  /** DELETE /api/v1/bank-charges/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/bank-charges/${id}`),
};
